/* ==========================================================================
   Landing « Le guide du frontalier en Suisse » — état et calculs côté client.
   Un seul curseur nourrit toute la page : hero, barre collante, tuiles,
   bloc d'achat. Rien n'est persisté (ni serveur, ni localStorage).
   Formules et barèmes : voir LOGIQUE-CALCULS.md du handoff.
   ========================================================================== */
(function () {
  'use strict';

  // La landing est répartie sur plusieurs sections Shopify : le point d'entrée
  // est un élément de configuration rendu par le layout, et l'on interroge
  // ensuite le document entier.
  var root = document.querySelector('[data-lp-config]');
  if (!root) return;

  var reduceMotion =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var cfg = {
    min: num(root.dataset.min, 1400),
    max: num(root.dataset.max, 5200),
    step: num(root.dataset.step, 50),
    salary: num(root.dataset.salary, 2200),
    multiplier: num(root.dataset.multiplier, 2.2),
    riskThreshold: num(root.dataset.riskThreshold, 6000),
    chapterCount: num(root.dataset.chapterCount, 10),
    priceLabel: root.dataset.priceLabel || '',
  };

  var state = {
    salary: clamp(cfg.salary, cfg.min, cfg.max),
    shown: 0,
    answers: {},
    stamped: [],
  };

  var raf = null;

  // Le quiz ne remonte qu'une seule fois par session, tant que le visiteur
  // n'a pas relancé le test.
  var quizTracked = false;

  /* ---------- utilitaires ---------- */

  function num(v, fallback) {
    var n = parseFloat(v);
    return isNaN(n) ? fallback : n;
  }

  function clamp(v, lo, hi) {
    return Math.min(hi, Math.max(lo, v));
  }

  // Typographie française : séparateur de milliers et espace avant € insécables.
  function fr(n) {
    return Math.round(n).toLocaleString('fr-FR');
  }

  function eur(n) {
    return fr(n) + ' €';
  }

  function signedEur(n) {
    return '+ ' + eur(n);
  }

  function each(selector, fn) {
    Array.prototype.forEach.call(document.querySelectorAll(selector), fn);
  }

  function setText(name, value) {
    each('[data-lp="' + name + '"]', function (el) {
      if (el.textContent !== value) el.textContent = value;
    });
  }

  /* ---------- mesure ---------- */

  // Point d'entrée unique des événements de la landing : on empile dans
  // window.dataLayer pour les outils de mesure, et l'on rediffuse un
  // CustomEvent pour tout script branché plus tard. Aucune dépendance tierce,
  // et la mesure ne doit jamais casser la page.
  function track(nom, detail) {
    var charge = detail || {};

    try {
      if (!window.dataLayer) window.dataLayer = [];
      var entree = { event: 'lp_' + nom };
      Object.keys(charge).forEach(function (cle) {
        entree[cle] = charge[cle];
      });
      window.dataLayer.push(entree);
    } catch (e) {
      /* dataLayer absent ou inutilisable : on continue sans bruit */
    }

    try {
      document.dispatchEvent(new CustomEvent('lp:' + nom, { detail: charge }));
    } catch (e) {
      /* CustomEvent indisponible : on ignore */
    }
  }

  /* ---------- valeurs dérivées ---------- */

  function questionCount() {
    var questions = document.querySelectorAll('[data-lp-question]');
    return questions.length || 4;
  }

  // Gain annuel en nombre, calculé sur la valeur cible et non sur le compteur
  // animé, pour que la mesure ne dépende pas de l'instant du clic.
  function gainYearValue() {
    return Math.round(Math.max(0, targetEur() - state.salary) * 12);
  }

  function targetEur() {
    return state.salary * cfg.multiplier;
  }

  function answeredCount() {
    return Object.keys(state.answers).length;
  }

  function totalRisk() {
    var total = 0;
    Object.keys(state.answers).forEach(function (qi) {
      total += state.answers[qi].risk;
    });
    return total;
  }

  function riskVerdict(answered, risk, questionCount) {
    if (answered < questionCount) {
      var left = questionCount - answered;
      return left === 1
        ? 'Réponds à la dernière question pour ton total.'
        : 'Réponds aux ' + left + ' questions restantes pour ton total.';
    }
    if (risk === 0) {
      return 'Tu maîtrises. Le guide te sert de contrôle et de modèles de courriers.';
    }
    if (risk < cfg.riskThreshold) {
      return 'Une zone floue, et elle se paie. Le chapitre concerné suffit à la fermer.';
    }
    return 'Gros trou dans la raquette. C’est plusieurs milliers d’euros, pour ' + cfg.priceLabel + '.';
  }

  function chapterCount() {
    return document.querySelectorAll('[data-lp-chap]').length || cfg.chapterCount;
  }

  function levelFor(count, total) {
    if (count < 3) return 'Débutant';
    if (count < 7) return 'Confirmé';
    if (count < total) return 'Presque pro';
    return 'Frontalier aguerri';
  }

  /* ---------- rendu ---------- */

  function render() {
    var salary = state.salary;
    var shown = state.shown;
    var gain = Math.max(0, shown - salary);
    var brutChf = targetEur() / 1.06 / 0.86;

    setText('minLabel', eur(cfg.min));
    setText('maxLabel', eur(cfg.max));
    setText('salaryLabel', eur(salary));
    setText('swissNet', eur(shown));
    setText('swissBrut', fr(Math.round(brutChf / 50) * 50) + ' CHF');
    setText('gainMonth', signedEur(gain));
    setText('gainYear', signedEur(gain * 12));
    setText('gainYearPlain', eur(gain * 12));
    setText('gain5', signedEur(gain * 60));
    setText('gainYearShort', fr(Math.round((gain * 12) / 1000)) + ' k€');

    var count = questionCount();
    var answered = answeredCount();
    var risk = totalRisk();

    setText('quizDone', answered + ' / ' + count);
    setText('risk', eur(risk));
    setText('verdict', riskVerdict(answered, risk, count));
    setText(
      'quizCta',
      risk > 0
        ? 'Fermer les ' + eur(risk) + ' pour ' + cfg.priceLabel
        : 'Je prends le guide · ' + cfg.priceLabel
    );

    each('[data-lp-progress]', function (el) {
      el.style.width = (answered / count) * 100 + '%';
    });

    each('[data-lp-opt]', function (btn) {
      var qi = btn.dataset.q;
      var picked = state.answers[qi];
      var on = picked && picked.option === btn.dataset.o;
      btn.classList.toggle('is-on', !!on);
      btn.classList.toggle('is-safe', num(btn.dataset.risk, 0) === 0);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var chapters = chapterCount();
    var stampCount = state.stamped.length;
    var left = chapters - stampCount;
    setText('stampCount', String(stampCount));
    setText('level', levelFor(stampCount, chapters));
    setText(
      'stampVerdict',
      left === 0
        ? 'Complet, le guide te sert de garde-fou'
        : left === 1
          ? '1 tampon à décrocher'
          : left + ' tampons à décrocher'
    );

    each('[data-lp-level-bar]', function (el) {
      el.style.width = (stampCount / chapters) * 100 + '%';
    });

    each('[data-lp-chap]', function (btn) {
      var done = state.stamped.indexOf(btn.dataset.i) >= 0;
      btn.classList.toggle('is-done', done);
      btn.setAttribute('aria-pressed', done ? 'true' : 'false');
    });

    // Ligne « Ton test : X en jeu » du bloc d'achat, seulement si risque > 0
    each('[data-lp-hasrisk]', function (el) {
      el.hidden = risk === 0;
    });
  }

  /* ---------- compteur animé ---------- */

  function tick() {
    var target = targetEur();
    var d = target - state.shown;
    if (Math.abs(d) > 1) {
      state.shown = state.shown + d * 0.14;
    } else if (state.shown !== target) {
      state.shown = target;
    }
    render();
    raf = window.requestAnimationFrame(tick);
  }

  /* ---------- interactions ---------- */

  each('[data-lp-range]', function (input) {
    input.min = cfg.min;
    input.max = cfg.max;
    input.step = cfg.step;
    input.value = state.salary;
    input.addEventListener('input', function (e) {
      state.salary = num(e.target.value, state.salary);
      if (reduceMotion) state.shown = targetEur();
      render();
    });

    // « change » et non « input » : on ne remonte que le relâchement du curseur.
    input.addEventListener('change', function (e) {
      state.salary = num(e.target.value, state.salary);
      track('simulateur', { salaire: state.salary, gain_annuel: gainYearValue() });
    });
  });

  each('[data-lp-opt]', function (btn) {
    btn.addEventListener('click', function () {
      state.answers[btn.dataset.q] = {
        option: btn.dataset.o,
        risk: num(btn.dataset.risk, 0),
      };
      render();
      maybeTrackQuiz();
    });
  });

  each('[data-lp-reset]', function (btn) {
    btn.addEventListener('click', function () {
      state.answers = {};
      quizTracked = false;
      render();
    });
  });

  each('[data-lp-chap]', function (btn) {
    btn.addEventListener('click', function () {
      var i = btn.dataset.i;
      var at = state.stamped.indexOf(i);
      if (at < 0) state.stamped.push(i);
      else state.stamped.splice(at, 1);
      render();
    });
  });

  function maybeTrackQuiz() {
    var count = questionCount();
    if (quizTracked || answeredCount() < count) return;
    quizTracked = true;
    var risk = totalRisk();
    track('quiz_termine', {
      risque: risk,
      verdict: riskVerdict(answeredCount(), risk, count),
    });
  }

  // Les appels à l'action vivent dans plusieurs sections : une seule écoute
  // déléguée sur le document suffit, quel que soit l'ordre de rendu.
  document.addEventListener('click', function (e) {
    var el = e.target;
    if (!el || typeof el.closest !== 'function') return;
    var cta = el.closest('[data-lp-cta]');
    if (!cta) return;
    track('cta', {
      emplacement: cta.getAttribute('data-lp-cta') || '',
      gain_annuel: gainYearValue(),
      risque: totalRisk(),
    });
  });

  /* ---------- aperçu des pages ---------- */

  // Fenêtre native : Échap la referme sans une ligne de code, et le clic sur le
  // fond a pour cible le <dialog> lui-même.
  // La carte sert aussi de prise pour faire défiler le carrousel : un geste qui
  // a bougé, ou que le navigateur a converti en défilement, ne doit pas ouvrir
  // l'agrandissement. Sans cette garde, un glissement raté s'achève en clic et
  // la fenêtre s'ouvre à la place — ce que l'on lit comme un bug.
  each('[data-lp-zoom]', function (btn) {
    var x0 = 0;
    var y0 = 0;
    var dragged = false;

    btn.addEventListener('pointerdown', function (e) {
      x0 = e.clientX;
      y0 = e.clientY;
      dragged = false;
    });

    btn.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - x0) > 8 || Math.abs(e.clientY - y0) > 8) dragged = true;
    });

    // Le navigateur annule le pointeur dès qu'il prend la main pour défiler.
    btn.addEventListener('pointercancel', function () {
      dragged = true;
    });

    btn.addEventListener('click', function () {
      if (dragged) {
        dragged = false;
        return;
      }
      var dlg = document.getElementById(btn.getAttribute('data-lp-zoom'));
      if (!dlg || typeof dlg.showModal !== 'function') return;
      dlg.showModal();
      track('apercu', { page: btn.getAttribute('data-lp-zoom') });
    });
  });

  each('.lp-zoom', function (dlg) {
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) dlg.close();
    });
  });

  /* ---------- barre d'achat ---------- */

  // La barre s'efface quand un bouton d'achat est déjà à l'écran : sur mobile
  // elle recouvrirait précisément ce qu'elle sert à atteindre.
  (function () {
    var bar = document.querySelector('[data-lp-bar]');
    if (!bar || typeof window.IntersectionObserver !== 'function') return;

    var zones = [];
    [document.getElementById('acheter'), document.querySelector('.lp-hero .lp-actions')].forEach(function (el) {
      if (el) zones.push(el);
    });
    if (!zones.length) return;

    var etats = [];
    zones.forEach(function (el, i) {
      el.setAttribute('data-lp-zone', i);
      etats[i] = false;
    });

    var io = new window.IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          etats[entry.target.getAttribute('data-lp-zone')] = entry.isIntersecting;
        });
        var visible = etats.some(function (v) {
          return v;
        });
        bar.classList.toggle('is-hidden', visible);
      },
      { threshold: 0.3 }
    );

    zones.forEach(function (el) {
      io.observe(el);
    });
  })();

  /* ---------- démarrage ---------- */

  if (reduceMotion) {
    state.shown = targetEur();
    render();
  } else {
    raf = window.requestAnimationFrame(tick);
  }

  window.addEventListener('pagehide', function () {
    if (raf) window.cancelAnimationFrame(raf);
  });
})();

/* ---------------------------------------------------------------------------
   Formules, feuille d'offre, départ au paiement.

   Un « groupe » réunit un sélecteur de formule et les formulaires
   correspondants — un formulaire par formule, parce que Shopify fige la
   variante du paiement accéléré au rendu. Il y a deux groupes sur la page :
   celui du bloc d'achat, et celui de la feuille qui s'ouvre au clic sur un
   appel à l'action. Même contrôleur pour les deux.

   Le départ au panier passe par /cart/update.js et non /cart/add.js : la
   quantité est absolue. Deux clics ne facturent pas deux exemplaires, et
   passer d'une formule à l'autre retire la précédente au lieu de l'empiler.
   Les autres articles du panier ne sont pas touchés. En cas d'échec, le
   formulaire part en POST classique vers return_to=/checkout.
--------------------------------------------------------------------------- */
(function () {
  var sheet = document.querySelector('[data-lp-sheet]');
  var sheetReady = false;
  var busy = false;

  function all(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  // Le bouton express de la formule en attente dort dans un <template> : tant
  // qu'il y est, le composant de Shopify ne s'initialise pas.
  function wake(host) {
    all('template[data-lp-express-tpl]', host).forEach(function (tpl) {
      tpl.parentNode.replaceChild(tpl.content.cloneNode(true), tpl);
    });
  }

  function leave(form) {
    busy = false;
    form.submit();
  }

  function checkout(form, group) {
    if (busy) return;
    busy = true;

    var field = form.querySelector('[name="id"]');
    var chosen = field && field.value;
    if (!chosen || !window.fetch) return leave(form);

    var updates = {};
    updates[chosen] = 1;

    // L'offre écartée quitte le panier, sinon les deux s'y empilent.
    var pick = group && group.querySelector('[data-lp-pick]');
    if (pick) {
      var solo = pick.getAttribute('data-solo-id');
      var pack = pick.getAttribute('data-pack-id');
      var out = chosen === solo ? pack : solo;
      if (out && out !== chosen) updates[out] = 0;
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        window.location.href = '/checkout';
      })
      .catch(function () {
        leave(form);
      });
  }

  function initGroup(group) {
    if (!group || group.hasAttribute('data-lp-ready')) return;
    group.setAttribute('data-lp-ready', '');

    var forms = all('[data-lp-offer-form]', group);
    if (!forms.length) return;

    forms.forEach(function (host) {
      var form = host.querySelector('.lp-buy__form');
      if (!form) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        checkout(form, group);
      });
    });

    var pick = group.querySelector('[data-lp-pick]');
    if (!pick) return;

    function apply(name) {
      forms.forEach(function (host) {
        var on = host.getAttribute('data-lp-offer-form') === name;
        host.hidden = !on;
        if (on) wake(host);
      });

      var price = pick.getAttribute('data-' + name + '-price');
      var label = pick.getAttribute('data-' + name + '-label');

      all('[data-lp-amount]', group).forEach(function (el) {
        el.innerHTML = price;
      });

      var head = group.querySelector('[data-lp-offerlabel]');
      if (head && label) head.textContent = label;

      // La barre collante annonce le montant du bloc d'achat, pas celui de la
      // feuille : elle reste en place quand la feuille se referme.
      if (group.closest('.lp-buy')) {
        var bar = document.querySelector('.lp-bar__price');
        if (bar) bar.innerHTML = price;
      }

      all('.lp-pick__opt', pick).forEach(function (el) {
        var input = el.querySelector('input');
        el.classList.toggle('is-on', !!(input && input.checked));
      });

      all('[data-lp-packincl]', group).forEach(function (el) {
        el.hidden = name !== 'pack';
      });
    }

    pick.addEventListener('change', function (e) {
      if (!/^lp-offre-/.test(e.target.name || '')) return;
      apply(e.target.value === 'pack' ? 'pack' : 'solo');
    });

    apply('solo');
  }

  function openSheet() {
    if (!sheetReady) {
      var tpl = sheet.querySelector('template[data-lp-sheet-tpl]');
      if (tpl) tpl.parentNode.replaceChild(tpl.content.cloneNode(true), tpl);
      initGroup(sheet.querySelector('[data-lp-group]'));
      sheetReady = true;
    }
    if (typeof sheet.showModal === 'function') sheet.showModal();
    else sheet.setAttribute('open', '');
  }

  document.addEventListener('click', function (e) {
    if (!e.target || typeof e.target.closest !== 'function') return;

    if (e.target.closest('[data-lp-sheet-close]')) {
      sheet.close();
      return;
    }

    if (e.defaultPrevented) return;
    var link = e.target.closest('a[href$="#acheter"]');
    if (!link) return;
    e.preventDefault();

    if (sheet) return openSheet();

    // Sans feuille — pack en brouillon, ou réglage décoché — l'appel à
    // l'action part directement au paiement, avec la formule affichée.
    var group = document.querySelector('.lp-buy [data-lp-group]') || document;
    var host = group.querySelector('[data-lp-offer-form]:not([hidden])');
    var form = host && host.querySelector('.lp-buy__form');
    if (form) checkout(form, group);
  });

  // Le clic sur le fond a pour cible le <dialog> lui-même.
  if (sheet) {
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet) sheet.close();
    });
  }

  all('.lp-buy [data-lp-group]').forEach(initGroup);
})();

/* ---------------------------------------------------------------------------
   Commandes du carrousel d'aperçu.

   Faire glisser reste possible, mais ne suffit pas : sur un téléphone, la
   carte fait près de 450 px de haut, le geste horizontal dérive vers la
   verticale, et c'est la page qui défile. Des flèches et des pastilles
   donnent un chemin qui ne dépend d'aucun geste.

   Elles n'apparaissent que si le carrousel déborde vraiment : sur grand écran
   c'est une grille, il n'y a rien à faire défiler.
--------------------------------------------------------------------------- */
(function () {
  var pages = document.querySelector('.lp-pages');
  var nav = document.querySelector('[data-lp-nav]');
  if (!pages || !nav) return;

  var items = Array.prototype.slice.call(pages.children);
  var dots = Array.prototype.slice.call(nav.querySelectorAll('[data-lp-nav-dot]'));
  var prev = nav.querySelector('[data-lp-nav-prev]');
  var next = nav.querySelector('[data-lp-nav-next]');
  if (!items.length || !prev || !next) return;

  var origin = items[0].offsetLeft;

  function overflows() {
    return pages.scrollWidth - pages.clientWidth > 8;
  }

  function index() {
    var left = pages.scrollLeft;
    var best = 0;
    var closest = Infinity;
    items.forEach(function (el, i) {
      var d = Math.abs(el.offsetLeft - origin - left);
      if (d < closest) {
        closest = d;
        best = i;
      }
    });
    return best;
  }

  var glide =
    typeof window.matchMedia !== 'function' ||
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function goTo(i) {
    var n = Math.max(0, Math.min(items.length - 1, i));
    var left = items[n].offsetLeft - origin;
    if (pages.scrollTo) pages.scrollTo({ left: left, behavior: glide ? 'smooth' : 'auto' });
    else pages.scrollLeft = left;
  }

  function sync() {
    var i = index();
    dots.forEach(function (dot, n) {
      dot.classList.toggle('is-on', n === i);
      dot.setAttribute('aria-current', n === i ? 'true' : 'false');
    });
    prev.disabled = i <= 0;
    next.disabled = i >= items.length - 1;
  }

  function refresh() {
    origin = items[0].offsetLeft;
    nav.hidden = !overflows();
    if (!nav.hidden) sync();
  }

  prev.addEventListener('click', function () {
    goTo(index() - 1);
  });

  next.addEventListener('click', function () {
    goTo(index() + 1);
  });

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      goTo(i);
    });
  });

  var pending;
  pages.addEventListener(
    'scroll',
    function () {
      clearTimeout(pending);
      pending = setTimeout(sync, 90);
    },
    { passive: true }
  );

  window.addEventListener('resize', refresh);

  // Les images sont en chargement différé : leur arrivée change les largeurs.
  if (document.readyState === 'complete') refresh();
  else window.addEventListener('load', refresh);
  refresh();
})();
